import React, { useId } from 'react';

export default function SellerNavSearch({ query, onQueryChange, resultCount }) {
  const resultCountId = useId();

  return (
    <div className="seller-nav-sidebar__search">
      <input
        type="search"
        className="seller-nav-sidebar__search-input"
        placeholder="Search seller tools"
        value={query}
        onChange={e => onQueryChange(e.target.value)}
        aria-label="Search seller tools and features"
      />
      {query.trim() && (
        <div
          className="seller-nav-sidebar__search-result-count"
          aria-live="polite"
          id={resultCountId}
        >
          {resultCount} result{resultCount !== 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
}
